import React from 'react';
import { SingleRecordList } from '../../components/common';

export const FinancingList: React.FC = () => {
  return (
    <SingleRecordList
      resource="financing"
      title="Финансирование"
    />
  );
};
